import { useEffect } from 'react'
import './Studio.css'

const Studio = () => {
  useEffect(() => {
    const prev = document.title
    document.title = 'NEXPA STUDIO'
    return () => { document.title = 'NEXPA AI' }
  }, [])
  return (
    <div className="studio-page">
      {/* Hero Section */}
      <section className="studio-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1>NEXPA Content Studio</h1>
            <p className="hero-subtitle">브랜드는 영상이 아니라, 메시지로 기억됩니다</p>
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="studio-philosophy">
        <div className="container">
          <div className="philosophy-content">
            <div className="philosophy-intro">
              <p className="philosophy-lead">
                NEXPA Content Studio는 산업·정책·공공 프로젝트의 복잡한 이야기를
                사람들이 이해하고 신뢰할 수 있는 콘텐츠로 설계합니다.
              </p>
              <p className="philosophy-sub">
                단순한 촬영과 편집을 넘어, 기관과 브랜드가 오래 활용할 수 있는 콘텐츠 자산을 만듭니다.
              </p>
              <div className="philosophy-buttons">
                <a href="mailto:darinarionrion@gmail.com" className="btn btn-primary">
                  콘텐츠 전략 문의하기
                </a>
                <a href="#projects" className="btn btn-secondary">
                  주요 프로젝트 보기
                </a>
              </div>
            </div>
            <h2 className="section-title">우리는 메시지를 먼저 설계합니다.</h2>
            <div className="philosophy-text">
              <p>
                좋은 콘텐츠는 보기 좋은 영상에서 끝나지 않습니다.<br />
                무엇을 전달할 것인지, 왜 필요한 프로젝트인지, 어떤 메시지로 기억될 것인지가 먼저 정리되어야 합니다.
              </p>
              <p>
                NEXPA는 경제·산업·정책 콘텐츠 경험을 바탕으로 복잡한 이야기를 쉽고 설득력 있는 콘텐츠 언어로 바꿉니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services */}
      <section className="studio-services">
        <div className="container">
          <h2 className="section-title">주요 서비스</h2>
          <div className="services-grid">
            <div className="service-card card">
              <div className="service-icon">📊</div>
              <h3>산업·정책 콘텐츠</h3>
              <p>경제, 산업, 투자, 정책 이슈를 대중이 이해할 수 있는 콘텐츠로 구조화합니다.</p>
            </div>
            <div className="service-card card">
              <div className="service-icon">🏛️</div>
              <h3>공공기관·지역 브랜딩</h3>
              <p>지역의 역사, 문화, 산업, 사람의 이야기를 연결해 공공성과 대중성을 갖춘 콘텐츠를 만듭니다.</p>
            </div>
            <div className="service-card card">
              <div className="service-icon">🎙️</div>
              <h3>CEO·전문가 인터뷰</h3>
              <p>대표, 전문가, 기관 관계자의 핵심 메시지를 신뢰도 높은 인터뷰 콘텐츠로 정리합니다.</p>
            </div>
            <div className="service-card card">
              <div className="service-icon">📱</div>
              <h3>디지털 채널 전략</h3>
              <p>유튜브와 디지털 플랫폼 운영까지 고려해 지속 가능한 콘텐츠 전략을 설계합니다.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Section */}
      <section className="studio-why">
        <div className="container">
          <div className="why-content card">
            <h2>왜 NEXPA Content Studio인가</h2>
            <ul className="why-list">
              <li>산업과 정책을 이해하는 콘텐츠 기획력</li>
              <li>CEO·전문가 인터뷰 기반 메시지 구조화 경험</li>
              <li>공공성과 대중성을 함께 고려한 스토리텔링</li>
              <li>단발성 영상이 아닌 장기 활용 가능한 콘텐츠 자산화</li>
              <li>NEXPA의 AI·교육·브랜딩 전략과 연결 가능한 확장성</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Director Profile */}
      <section className="studio-director">
        <div className="container">
          <h2 className="section-title">김현경 공동대표</h2>
          <div className="director-card card">
            <div className="director-info">
              <div className="director-header">
                <p className="director-title">시사경제 전문 PD / 콘텐츠 전략 디렉터</p>
              </div>
              <p className="director-bio">
                김현경 공동대표는 한국경제TV 생방송, CEO 인터뷰, 경제·산업 콘텐츠, 투자 컨퍼런스,
                유튜브 오리지널 콘텐츠 등을 기획·제작해온 콘텐츠 전문가입니다.
              </p>
              <p className="director-bio">
                NEXPA에서는 산업·정책·브랜드 콘텐츠 사업부를 총괄하며, 기관과 기업의 메시지를
                신뢰도 높은 콘텐츠 자산으로 설계합니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Projects */}
      <section className="studio-projects" id="projects">
        <div className="container">
          <h2 className="section-title">주요 프로젝트</h2>
          <div className="projects-list">
            <div className="project-item">
              <div className="project-year">2026</div>
              <div className="project-content">
                <h4>NSI 인사이트 콘텐츠 제작</h4>
                <p>경제·산업 이슈를 다큐멘터리형 콘텐츠로 풀어낸 인사이트 영상 프로젝트</p>
              </div>
            </div>
            <div className="project-item">
              <div className="project-year">2025</div>
              <div className="project-content">
                <h4>연천 지역 브랜딩 콘텐츠 프로젝트</h4>
                <p>지역의 역사·문화·관광 자원을 현대적 콘텐츠 언어로 재해석한 공공 브랜딩 프로젝트</p>
              </div>
            </div>
            <div className="project-item">
              <div className="project-year">2022</div>
              <div className="project-content">
                <h4>CLASS101 주식·부동산 컨퍼런스 총괄 기획</h4>
                <p>경제·투자·부동산 전문가 기반 온라인 컨퍼런스 콘텐츠 기획 및 운영</p>
              </div>
            </div>
            <div className="project-item">
              <div className="project-year">2013–2022</div>
              <div className="project-content">
                <h4>한국경제TV 유튜브 오리지널 콘텐츠 제작</h4>
                <p>경제·산업·라이프스타일 기반 디지털 오리지널 콘텐츠 기획 및 제작</p>
              </div>
            </div>
            <div className="project-item">
              <div className="project-year">2012–2017</div>
              <div className="project-content">
                <h4>한국경제TV CEO 인터뷰 및 생방송 제작</h4>
                <p>상장사 CEO 및 산업 전문가 인터뷰 중심 경제 프로그램 제작</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="studio-process">
        <div className="container">
          <h2 className="section-title">제작 프로세스</h2>
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">01</div>
              <h4>메시지 진단</h4>
              <p>핵심 메시지와 콘텐츠 목적을 정의합니다.</p>
            </div>
            <div className="process-step">
              <div className="step-number">02</div>
              <h4>스토리 구조 설계</h4>
              <p>복잡한 정보를 이해하기 쉬운 이야기로 정리합니다.</p>
            </div>
            <div className="process-step">
              <div className="step-number">03</div>
              <h4>콘텐츠 제작</h4>
              <p>기획, 촬영, 인터뷰, 편집, 그래픽을 통합해 완성합니다.</p>
            </div>
            <div className="process-step">
              <div className="step-number">04</div>
              <h4>콘텐츠 자산화</h4>
              <p>홈페이지, 유튜브, 제안서, 행사, 아카이브 등으로 확장 활용합니다.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="studio-cta">
        <div className="container">
          <div className="cta-content card">
            <h2>당신의 프로젝트는 어떤 메시지로<br />기억되어야 합니까?</h2>
            <p>
              NEXPA Content Studio는 기관과 브랜드의 이야기를<br />
              사람들이 이해하고 신뢰할 수 있는 콘텐츠로 설계합니다.
            </p>
            <a href="mailto:darinarionrion@gmail.com" className="btn btn-primary">
              프로젝트 문의하기
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Studio
